import type { UseMutationOptions } from '@tanstack/react-query';

import type {
  RebookAppointmentParams,
  RebookAppointmentResponse,
} from '@/api/booking/rebookAppointmentMutation';

export type RebookParams = RebookAppointmentParams;

interface RebookApiError {
  code: string;
  message: string;
}

const REBOOK_CAN_NOT_REBOOK_CODE = 'sale.errors.canNotRebook';

export const isCanNotRebookError = (error: unknown): error is RebookApiError =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  (error as RebookApiError).code === REBOOK_CAN_NOT_REBOOK_CODE;

export interface UseRebookMutationCustomOptions {
  onBarberUnavailable?: () => void;
  onServiceUnavailable?: () => void;
}

export type UseRebookMutationOptions = Omit<
  UseMutationOptions<RebookAppointmentResponse, Error, RebookParams>,
  'mutationFn'
> &
  UseRebookMutationCustomOptions;
